import { cn } from "@omni/utils/styles";

import { useDeliveryItemContext } from "@/components/Product/ECommerce/components/delivery/components/deliveryTypes/deliveryItem/context/deliveryItem.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

export const NoStore = ({ className }: Props) => {
    const { t } = useGranite();

    const { isBoxArticle, preferredStore } = useDeliveryItemContext();

    if (isBoxArticle || preferredStore) return null;

    return (
        <p className={cn("tw:text-sm tw:font-light tw:m-0", className)}>
            {t("general.ecommerce.clickAndCollect.noStore")}
        </p>
    );
};
